import { ImageRendition } from '../../utils/ImageUtils';

export type MLogoContainerColor = 'branded' | 'color' | 'grey' | 'white' | 'background-aware' | 'alternate-logo';
export type MLogoContainerAlignment = 'Bottom Left' | 'Center Left' | 'Bottom Centered' | 'Centered';

export enum MLogoContainerBackgroundColor {
  Standard = 'standard',
  Inverse = 'inverse',
  Alternate = 'alternate',
  ColorScheme1 = 'color-scheme1',
  ColorScheme2 = 'color-scheme2',
  ColorScheme3 = 'color-scheme3',
  ColorScheme4 = 'color-scheme4',
  ColorScheme5 = 'color-scheme5',
  ColorScheme6 = 'color-scheme6',
  ColorScheme7 = 'color-scheme7',
}

export interface MLogoContainerBaseProps {
  brand: string;
  backgroundColor?: MLogoContainerBackgroundColor | string;
  color?: MLogoContainerColor;
  aspectRatio: string;
  width: number | string;
  height: number | string;
  alignment?: MLogoContainerAlignment;
  hoverColor?: string;
  ariaRole?: string;
  logopath?: string;
  aspectMode?: string;
  brandFullName?: string;
  customClass?: string;
  /** DAC (Digital Asset Center) logo URL for regular image formats (PNG, JPG, etc.) */
  dacLogoUrl?: string;
  /** Flag to indicate if this is a DAC logo (true) or SVG logo (false) */
  isDACLogo?: boolean;
  /** Fetch priority for performance optimization */
  fetchpriority?: 'high' | 'low' | 'auto';
  /** Control lazy loading. When false, image loads eagerly. Defaults to true */
  isLazy?: boolean;
  /** Renditions for dynamic image handling */
  renditions?: ImageRendition[];
  /** Whether the image is dynamic (affects URL construction) */
  dynamic?: boolean;
}

export interface MLogoContainerAsLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isLink: true;
  linkUrl: string;
}

export interface MLogoContainerAsSpanProps extends React.HTMLAttributes<HTMLSpanElement> {
  isLink?: false | undefined;
  linkUrl?: undefined;
}

export type MLogoContainerProps = (MLogoContainerAsSpanProps | MLogoContainerAsLinkProps) & MLogoContainerBaseProps;

export enum MLogoContainerBrand {
  MI = 'brand-logo-MI',
  MBS = 't-program-logo-color-s',
  JW = 'brand-logo-JW',
  RZ = 'brand-logo-rz',
}

export enum MLogoContainerSize {
  S = 's',
  M = 'm',
  L = 'l',
}
